import { getCloudinaryUrl } from "@/lib/cloudinary";

export const pastWorkImages = [
  { src: getCloudinaryUrl("past-work1"), alt: "Soin balinais - Avant/Après" },
  { src: getCloudinaryUrl("past-work2"), alt: "Chevelure lumineuse après soin" },
  { src: getCloudinaryUrl("past-work3"), alt: "Massage du cuir chevelu" },
  { src: getCloudinaryUrl("past-work4"), alt: "Résultat final, coupe élégante" },
  { src: getCloudinaryUrl("past-work5"), alt: "Application de produits nourrissants" },
  { src: getCloudinaryUrl("past-work6"), alt: "Coiffure soignée et brillante" },
  { src: getCloudinaryUrl("past-work7"), alt: "Texture sublimée" },
  { src: getCloudinaryUrl("past-work8"), alt: "Cheveux en pleine santé" },
  { src: getCloudinaryUrl("past-work9"), alt: "Préparation du soin personnalisé" },
  { src: getCloudinaryUrl("past-work10"), alt: "Finitions professionnelles" },
];
